"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const C2dDefaultShader_1 = require("./C2dDefaultShader");
const WebGLGrayscaleShader_1 = require("../../webgl/shaders/WebGLGrayscaleShader");
class C2dGrayscaleShader extends C2dDefaultShader_1.C2dDefaultShader {
    constructor(context) {
        super(context);
        this._amount = 1;
    }
    static getWebGL() {
        return WebGLGrayscaleShader_1.WebGLGrayscaleShader;
    }
    set amount(v) {
        this._amount = v;
        this.redraw();
    }
    get amount() {
        return this._amount;
    }
    useDefault() {
        return this._amount === 0;
    }
    _beforeDrawEl(obj) {
        obj.target.context.filter = "grayscale(" + this._amount + ")";
    }
    _afterDrawEl(obj) {
        obj.target.context.filter = "none";
    }
}
exports.C2dGrayscaleShader = C2dGrayscaleShader;
//# sourceMappingURL=C2dGrayscaleShader.js.map